import { calculateAge } from "./parsers";

/**
 * Simple utility to check if patient is under 18 based on date of birth
 * Used by UnifiedCaregiverSection for age-based conditional logic
 */
export const isPatientUnder18 = (dob) => {
  if (!dob) return false;

  const age = calculateAge(dob);
  return age < 18;
};
